/* lua.js generated code 0.3.0 */

require("clover/gamePlay/CreateGameSceneLogic")
var [StartPanel, StartPanelEvent] = unpack(require("clover/panel/StartPanel"))
var StartEditorLevelLogic = xClass("StartEditorLevelLogic")
StartEditorLevelLogic.checkCanStart = function (levelId) {
    var [success, errCode] = UserLevel.getInstance().canStartLevel(levelId, table())
    if (success || errCode === ZooErrorCode.ENERGY_NOT_ENOUGH) {
        return true
    } else {
        // FIXME: multi result
        return [false, errCode]
    }
}
StartEditorLevelLogic.create = function (levelId) {
    var self = this
    var [success, errCode] = self.checkCanStart(levelId)
    if (!success) {
        // FIXME: multi result
        return [null, errCode]
    }
    // WARN: maybe multi result
    return [StartEditorLevelLogic.new(levelId), undefined]
}
StartEditorLevelLogic.prototype.ctor = function (levelId) {
    var self = this
    self.levelId = levelId
    self.initProps = table()
    self.isBusy = false
    self.waitingPanelAnim = false
}
StartEditorLevelLogic.prototype.start = function (successCallback, failCallback) {
    var self = this
    if (self.isBusy) {
        return 
    }
    self.successCallback = successCallback
    self.failCallback = failCallback
    var panel = StartPanel.create(self.levelId, self.initPropConfig(), self.scoreConfig(), self.levelInfo())
    panel.on(StartPanelEvent.StartClick, function (event) {
        if (self.waitingPanelAnim || self.isBusy) {
            return 
        }
        self.isBusy = true
        PopoutManager.getInstance().removeAll()
        self.checkEnergy()
    })
    panel.on(StartPanelEvent.PrePropSelect, function (event) {
        if (self.waitingPanelAnim) {
            return 
        }
        table.insert(self.initProps, event.propId)
        var [success, errCode] = UserLevel.getInstance().canStartLevel(self.levelId, self.initProps)
        if (success) {
            event.success = true
        } else {
            table.removebyvalue(self.initProps, event.propId)
            event.success = false
            event.errCode = errCode
        }
    })
    panel.on(StartPanelEvent.PrePropCancel, function (event) {
        if (self.waitingPanelAnim) {
            return 
        }
        table.removebyvalue(self.initProps, event.propId)
    })
    panel.on(StartPanelEvent.Close, function (event) {
        if (self.waitingPanelAnim) {
            return 
        }
        event.target.onClose()
        if (type(self.failCallback) === "function") {
            self.failCallback()
        }
    })
    panel.on(StartPanelEvent.StartAnim, function (event) {
        self.waitingPanelAnim = true
    })
    panel.on(StartPanelEvent.FinishAnim, function (event) {
        self.waitingPanelAnim = false
    })
    panel.popup(true)
}
StartEditorLevelLogic.prototype.scoreConfig = function () {
    var self = this
    var score = UserScore.getScore(self.levelId)
    var levelConfig = LevelConfigManager.getInstance().getGameplayLevelConfigByID(self.levelId, false, score.star) || table()
    var scoreTargets = levelConfig.scoreTargets || table()
    return table(
        [1, "score", 0],
        [1, "star", 0],
        [1, "totalStar", Math.max($len(scoreTargets), score.star)]
    )
}
StartEditorLevelLogic.prototype.initPropConfig = function () {
    var self = this
    var ret = table()
    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(self.levelId)
    var initPropMeta = MetaManager.getGameModePropByModeId(gameMode)
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()
    for (var i = 1, v = (initPropMeta && initPropMeta.initProps_item || table())[1]; v; i++, v = (initPropMeta && initPropMeta.initProps_item || table())[i]) {
        var elem = table([1, "itemId", v])
        elem.num = UserProp.getInstance().getPropNumber(v)[0]
        var goodsId = UserDealData.getGoodsIdForProp(v)
        var discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
        var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
        var discountGoodsMeta = MetaManager.getInstance().getGoodsMeta(discountGoodsId)
        var payType = UserDealData.getGoodsPayType(goodsId)
        if (payType === UserDealPayType.kCoin) {
            elem.coin = goodsMeta.coin
            if (discountGoodsMeta) {
                elem.discountCoin = discountGoodsMeta.discountCoin
            }
        } else if (payType === UserDealPayType.kCash) {
            elem.cash = goodsMeta.qCash
            if (discountGoodsMeta) {
                elem.discountCash = discountGoodsMeta.discountQCash
            }
        }
        elem.locked = false
        elem.level = goodsMeta.level
        table.insert(ret, elem)
    }
    return ret
}
StartEditorLevelLogic.prototype.levelInfo = function () {
    var self = this
    return table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
}
StartEditorLevelLogic.prototype.checkEnergy = function () {
    var self = this
    var [success, errCode] = UserLevel.getInstance().canStartLevel(self.levelId, self.initProps)
    if (success) {
        self.startLevel()
    } else if (errCode === ZooErrorCode.ENERGY_NOT_ENOUGH) {
        // TODO: 召唤出精力面板！
    } else {
        Toast.make(getText("error.tip." + tostring(errCode)))
    }
}
StartEditorLevelLogic.prototype.startLevel = function () {
    var self = this
    function onSuccess() {
        if (type(self.successCallback) === "function") {
            self.successCallback()
        }
        CreateGameSceneLogic.create(self.levelId, self.initProps).startGamePlayScene()
    }
    function onFail(event) {
        Toast.make(getText("error.tip." + tostring(event.data)))
        if (type(self.failCallback) === "function") {
            self.failCallback()
        }
    }
    function onCancel() {
        if (type(self.failCallback) === "function") {
            self.failCallback()
        }
    }
    UserLevel.getInstance().startLevel(self.levelId, self.initProps, onSuccess, onFail, onCancel)
}
module.exports = StartEditorLevelLogic
